export const timeRegexAmPmFormat = /^(0[0-9]|10|11|12):([0-5]\d)\s?(?:am|pm)$/i;
